"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("../classnames"));
var Thumbnail = function (_a) {
    var _b = _a.as, Element = _b === void 0 ? "div" : _b, className = _a.className, image = _a.image, _c = _a.size, size = _c === void 0 ? "small" : _c, _d = _a.square, square = _d === void 0 ? false : _d, title = _a.title;
    return (react_1.default.createElement(Element, { className: classnames_1.default("chq-tmb", className, {
            "chq-tmb-md": size === "medium",
            "chq-tmb-lg": size === "large",
            "chq-tmb-sq": square
        }), style: { backgroundImage: "url(" + image + ")" }, title: title }));
};
exports.default = Thumbnail;
